module.exports = __webpack_public_path__ + "img/logo-reliance.4e79823e.png";